module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_wemakeprice_m.99b421f40d5771233cb0ab6eb50ea329.png";